import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    fontFamily: 'roboto',
    fontSize: '2xs',
    textTransform: 'none',
    lineHeight: '1.125',
  },
  buttonBaseSpanProps: {
    fontWeight: 'extrabold',
    fontSize: '2xs',
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
  },
  buttonBaseBox: {
    fontSize: 'sm',
    fontWeight: 'black',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
